import React from 'react';
import PropTypes from 'prop-types';

const SelectOption = props => {
  const { disabled, text, value } = props;
  const optionValue = value === null ? '' : value;

  return (
    <option value={optionValue} disabled={disabled}>
      {text}
    </option>
  );
};

SelectOption.propTypes = {
  disabled: PropTypes.bool,
  text: PropTypes.string,
  value: PropTypes.any
};

SelectOption.defaultProps = {
  disabled: false
};

export default SelectOption;
